export const environment = {
  app: {
    apiUrl: 'https://dev.api.tramifast.com.mx',
  },
};
